require('./cmIntervenerItem.scss');

const PropTypes = require('prop-types');

const React = require('react');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;
const classNames = require('classnames');
const {
    CM_INTERVENER_ITEM_TITULAR,
    CM_INTERVENER_ITEM_AUTORIZADO,
    CM_INTERVENER_ITEM_REP,
    CM_INTERVENER_ITEM_ADMIN,
    CM_INTERVENER_ITEM_APODERADO,
} = require('../../../constants/constants');

class CmIntervenerItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleIntervenerNameChange = this.handleIntervenerNameChange.bind(
            this,
        );
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(
            this,
        );
        this.handleRemoveIntervener = this.handleRemoveIntervener.bind(this);
        this.renderIntervenerName = this.renderIntervenerName.bind(this);
        this.getIntervenerOptions = this.getIntervenerOptions.bind(this);
    }

    handleIntervenerNameChange(e) {
        const { index, onIntervenerNameChange } = this.props;
        onIntervenerNameChange(index, e.value);
    }

    handleIntervenerTypeChange(e) {
        const { index, onIntervenerTypeChange } = this.props;
        onIntervenerTypeChange(index, e.value);
    }

    handleRemoveIntervener() {
        const { index, onIntervenerRemove } = this.props;
        onIntervenerRemove(index);
    }

    renderIntervenerName() {
        const {
            originalInterveners,
            intervenerName,
            isOnlyIntervener,
        } = this.props;

        const intervenersSelect = originalInterveners.map(item => {
            return {
                label: item.get('name'),
                value: item.get('name'),
            };
        });

        const nameLabel = formatText('brokerCM-intervenerLabel');

        if (this.props.nameLabelFormat) {
            return (
                <div className="cm-intervener-item__label-wrapper">
                    <label>{intervenerName}</label>
                </div>
            );
        } else {
            return (
                <div className="cm-intervener-item__name-wrapper">
                    <OKSelect
                        label={nameLabel}
                        name="advanced-search-product"
                        className="cm-intervener-item__select cm-intervener-item__select--first"
                        options={intervenersSelect.toJS()}
                        value={intervenerName}
                        onChange={this.handleIntervenerNameChange}
                        clearable={false}
                        searchable={false}
                        placeholder="Selecciona un interviniente"
                        disabled={isOnlyIntervener}
                    />
                </div>
            );
        }
    }

    getIntervenerOptions(originaIntervenerType, limitIntervenerOptions) {
        const holder = formatText('brokerIntevenerItem-holder');
        const authorized = formatText('brokerIntevenerItem-authorized');
        const legalRepresentative = formatText(
            'brokerIntevenerItem-legalRepresentative',
        );
        const administrator = formatText('brokerIntevenerItem-administrator');
        const empowered = formatText('brokerIntevenerItem-empowered');

        const allIntervenerOptions = [
            { value: CM_INTERVENER_ITEM_TITULAR, label: holder.toUpperCase() },
            {
                value: CM_INTERVENER_ITEM_AUTORIZADO,
                label: authorized.toUpperCase(),
            },
            {
                value: CM_INTERVENER_ITEM_REP,
                label: legalRepresentative.toUpperCase(),
            },
            {
                value: CM_INTERVENER_ITEM_ADMIN,
                label: administrator.toUpperCase(),
            },
            {
                value: CM_INTERVENER_ITEM_APODERADO,
                label: empowered.toUpperCase(),
            },
        ];
        let intervenerOptions;
        switch (originaIntervenerType.toUpperCase()) {
            case CM_INTERVENER_ITEM_TITULAR:
                return (intervenerOptions = allIntervenerOptions);
            case CM_INTERVENER_ITEM_AUTORIZADO:
                return (intervenerOptions = [
                    {
                        value: CM_INTERVENER_ITEM_AUTORIZADO,
                        label: authorized.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_REP,
                        label: legalRepresentative.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_ADMIN,
                        label: administrator.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_APODERADO,
                        label: empowered.toUpperCase(),
                    },
                ]);
            case CM_INTERVENER_ITEM_REP:
                return (intervenerOptions = [
                    {
                        value: CM_INTERVENER_ITEM_AUTORIZADO,
                        label: legalRepresentative.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_ADMIN,
                        label: administrator.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_APODERADO,
                        label: empowered.toUpperCase(),
                    },
                ]);
            case CM_INTERVENER_ITEM_ADMIN:
                return (intervenerOptions = [
                    {
                        value: CM_INTERVENER_ITEM_ADMIN,
                        label: administrator.toUpperCase(),
                    },
                    {
                        value: CM_INTERVENER_ITEM_APODERADO,
                        label: empowered.toUpperCase(),
                    },
                ]);
            case CM_INTERVENER_ITEM_APODERADO:
                return (intervenerOptions = [
                    {
                        value: CM_INTERVENER_ITEM_APODERADO,
                        label: empowered.toUpperCase(),
                    },
                ]);
        }

        return limitIntervenerOptions
            ? intervenerOptions
            : allIntervenerOptions;
    }

    render() {
        const {
            intervenerType,
            isOnlyOwner,
            limitIntervenerOptions,
            originaIntervenerType,
        } = this.props;

        const typeLabel = formatText('broker-stockIntervenerItemTypeLabel');

        const intervenerOptions = this.getIntervenerOptions(
            originaIntervenerType,
            limitIntervenerOptions,
        );

        const iconCrossClassName = classNames(
            'icon-quitar cm-intervener-item__icon-cross',
            {
                'cm-intervener-item__icon-cross--hidden': isOnlyOwner,
            },
        );

        const removeIcon = this.props.showRemoveIcon ? (
            <i
                className={iconCrossClassName}
                onClick={this.handleRemoveIntervener}
            />
        ) : null;

        return (
            <div className="cm-intervener-item clearfix">
                {this.renderIntervenerName()}

                <div className="cm-intervener-item__type-wrapper">
                    <OKSelect
                        label={typeLabel}
                        name="advanced-search-product"
                        className="cm-intervener-item__select"
                        options={intervenerOptions}
                        value={intervenerType}
                        onChange={this.handleIntervenerTypeChange}
                        clearable={false}
                        searchable={false}
                        showLabel={true}
                        disabled={isOnlyOwner}
                    />
                </div>
                {removeIcon}
            </div>
        );
    }
}

CmIntervenerItem.defaultProps = {
    originalInterveners: [],
    isOnlyIntervener: false,
    isOnlyOwner: false,
    nameLabelFormat: true,
    showInterventionLabel: false,
    showRemoveIcon: true,
    limitIntervenerOptions: true,
};

CmIntervenerItem.propTypes = {
    nameLabelFormat: PropTypes.bool,
    showInterventionLabel: PropTypes.bool,
    index: PropTypes.number,
    originalInterveners: PropTypes.object,
    intervenerName: PropTypes.string,
    intervenerType: PropTypes.string.isRequired,
    isOnlyIntervener: PropTypes.bool,
    isOnlyOwner: PropTypes.bool,
    onIntervenerNameChange: PropTypes.func,
    onIntervenerTypeChange: PropTypes.func,
    onIntervenerRemove: PropTypes.func,
    showRemoveIcon: PropTypes.bool,
    limitIntervenerOptions: PropTypes.bool,
    originaIntervenerType: PropTypes.string.isRequired,
};

module.exports = CmIntervenerItem;
